<template>
  <div class="wa-step">
    <h2 class="wa-step__heading">
      {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.situation.heading') }}
    </h2>
    <p class="wa-step__lead">
      {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.situation.lead') }}
    </p>
    <div
      class="wa-radio-cards"
      role="radiogroup"
      :aria-label="t('storeParameters.services.whatsappBusinessParameter.onboarding.situation.heading')"
    >
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="wa-radio-card"
        :class="{ 'wa-radio-card--selected': modelValue === option.value }"
        role="radio"
        :aria-checked="modelValue === option.value"
        @click="$emit('update:modelValue', option.value)"
      >
        <span class="wa-radio-card__indicator" />
        <span class="wa-radio-card__content">
          <span class="wa-radio-card__label">{{ t(option.labelKey) }}</span>
          <span
            v-if="option.descriptionKey"
            class="wa-radio-card__description"
          >{{ t(option.descriptionKey) }}</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import type { OnboardingPath } from '@/types/whatsapp-onboarding';

export default defineComponent({
  name: 'WhatsappSituationStep',

  props: {
    modelValue: {
      type: String as PropType<OnboardingPath | null>,
      default: null,
    },
  },

  emits: ['update:modelValue'],

  setup() {
    const { t } = useI18n();
    const options = [
      {
        value: 'none' as OnboardingPath,
        labelKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.none.label',
        descriptionKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.none.description',
      },
      {
        value: 'other_bsp' as OnboardingPath,
        labelKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.otherBsp.label',
        descriptionKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.otherBsp.description',
      },
      {
        value: 'wa_app' as OnboardingPath,
        labelKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.waApp.label',
        descriptionKey: 'storeParameters.services.whatsappBusinessParameter.onboarding.situation.options.waApp.description',
      },
    ];
    return { t, options };
  },
});
</script>
